module.exports = __webpack_public_path__ + "img/cover3-1920.bbbef5f9.jpg";